import dynamic from "next/dynamic";
import React from "react";

// Templates
const BSRContentPage = dynamic(
  () => import("@components/__templates__/BSRContentPage/BSRContentPage")
);
const CampaignLandingPage = dynamic(
  () =>
    import("@components/__templates__/CampaignLandingPage/CampaignLandingPage")
);
const ClusterPage = dynamic(
  () => import("@components/__templates__/ClusterPage/ClusterPage")
);
const Content = dynamic(
  () => import("@components/__templates__/Content/Content")
);
const Content2019Page = dynamic(
  () => import("@components/__templates__/Content2019Page/Content2019Page")
);
const ContributorProfileDetail = dynamic(
  () =>
    import(
      "@components/__templates__/ContributorProfileDetail/ContributorProfileDetail"
    )
);
const DPOPage = dynamic(
  () => import("@components/__templates__/DPOPage/DPOPage")
);
const EELandingPage = dynamic(
  () => import("@components/__templates__/EELandingPage/EELandingPage")
);
const EMBAGTemplate = dynamic(
  () => import("@components/__templates__/EMBAGTemplate/EMBAGTemplate")
);
const EventsDetail = dynamic(
  () => import("@components/__templates__/EventsDetail/EventsDetail")
);
const FacultyProfileDetail = dynamic(
  () =>
    import(
      "@components/__templates__/FacultyProfileDetail/FacultyProfileDetail"
    )
);
const InteractSSO = dynamic(
  () => import("@components/__templates__/InteractSSO/InteractSSO")
);
const NewsDetail = dynamic(
  () => import("@components/__templates__/NewsDetail/NewsDetail")
);
const ProgrammeDetailsPage = dynamic(
  () =>
    import(
      "@components/__templates__/ProgrammeDetailsPage/ProgrammeDetailsPage"
    )
);
const PublicationDetail = dynamic(
  () => import("@components/__templates__/PublicationDetail/PublicationDetail")
);
const StoryPage = dynamic(
  () => import("@components/__templates__/StoryPage/StoryPage")
);
const StudentProfileDetail = dynamic(
  () =>
    import(
      "@components/__templates__/StudentProfileDetail/StudentProfileDetail"
    )
);
const SuccessBrochurePage = dynamic(
  () =>
    import("@components/__templates__/SuccessBrochurePage/SuccessBrochurePage")
);
const RegisterInterestSuccessPage = dynamic(
  () =>
    import(
      "@components/__templates__/RegisterInterestSuccessPage/RegisterInterestSuccessPage"
    )
);
const CommonSuccessPage = dynamic(
  () => import("@components/__templates__/CommonSuccessPage/CommonSuccessPage")
);
const ResearchDetailsPage = dynamic(
  () =>
    import("@components/__templates__/ResearchDetailsPage/ResearchDetailsPage")
);

// Sublayouts
const Sublayout = dynamic(() => import("@components/__SubLayouts__/Sublayout"));

// Components
const C284_DonationTool_NonBlackbaud = dynamic(
  () =>
    import(
      "@components/C284_DonationTool_NonBlackbaud/C284_DonationTool_NonBlackbaud"
    )
);
const C285_DonationTool_GivingTech = dynamic(
  () =>
    import(
      "@components/C285_DonationTool_GivingTech/C285_DonationTool_GivingTech"
    )
);
const c194PromotionalResearch = dynamic(
  () =>
    import("@components/C19.4_PromotionalResearch/C19.4_PromotionalResearch")
);
const ArticleSummary = dynamic(
  () => import("@components/ArticleSummary/ArticleSummary")
);
const C031_SubNavigationDE = dynamic(
  () => import("@components/C03.1_SubNavigationDE/C03.1_SubNavigationDE")
);
const C03_AnchorHeading = dynamic(
  () => import("@components/C03_AnchorHeading/C03_AnchorHeading")
);
const C03_SubNavigation = dynamic(
  () => import("@components/C03_SubNavigation/C03_SubNavigation")
);
const C09_VideoVimeoAndYoutube = dynamic(
  () => import("@components/C09_VideoVimeoAndYoutube/C09_VideoVimeoAndYoutube")
);
const C11_VerticalAccordion = dynamic(
  () => import("@components/C11_VerticalAccordion/C11_VerticalAccordion")
);
const C141_FacultyProfilePublications = dynamic(
  () =>
    import(
      "@components/C14.1_FacultyProfilePublications/C14.1_FacultyProfilePublications"
    )
);
const C15_SocialSharing = dynamic(
  () => import("@components/C15_SocialSharing/C15_SocialSharing")
);
const C15_1_SocialSharing = dynamic(
  () => import("@components/C15_SocialSharing/C15.1_FloatingSocialSharing")
);
const C16_RichTextFullWidth = dynamic(
  () => import("@components/C16_RichTextFullWidth/C16_RichTextFullWidth")
);
const C19_1_PromotionalArticlesBSR = dynamic(
  () =>
    import(
      "@components/C19.1_PromotionalArticlesBSR/C19.1_PromotionalArticlesBSR"
    )
);
const C19_2_PromotionalArticlesNews = dynamic(
  () =>
    import(
      "@components/C19.2_PromotionalArticlesNews/C19.2_PromotionalArticlesNews"
    )
);
const C19_3_1_PromotionalFullWidth = dynamic(
  () =>
    import(
      "@components/C19.3.1_PromotionalFullWidth/C19.3.1_PromotionalFullWidth"
    )
);
const C20_2_PromotionalEventsFullWidth = dynamic(
  () =>
    import(
      "@components/C20.2_PromotionalEventsFullWidth/C20.2_PromotionalEventsFullWidth"
    )
);
const C200_1_BrandIconTitle = dynamic(
  () => import("@components/C200_1_BrandIconTitle/C200_1_BrandIconTitle")
);
const C203_PopularTopics = dynamic(
  () => import("@components/C203_PopularTopics/C203_PopularTopics")
);
const C207_PopularAuthors = dynamic(
  () => import("@components/C207_PopularAuthors/C207_PopularAuthors")
);
const C20_1_PromotionalArticleSingle = dynamic(
  () =>
    import("@components/C20_PromotionalArticles/C20_1_PromotionalArticleSingle")
);
const C20_1_PromotionalManuallyPopulated = dynamic(
  () =>
    import(
      "@components/C20_PromotionalArticles/C20_1_PromotionalManuallyPopulated"
    )
);
const C20_PromotionalArticles = dynamic(
  () => import("@components/C20_PromotionalArticles/C20_PromotionalArticles")
);
const C210_2_ArticleRichTextTriple = dynamic(
  () =>
    import(
      "@components/C210_2_ArticleRichTextTriple/C210_2_ArticleRichTextTriple"
    )
);
const C210_3_ArticleBlockQuote = dynamic(
  () => import("@components/C210_3_ArticleBlockQuote/C210_3_ArticleBlockQuote")
);
const C214_TopicBanner = dynamic(
  () => import("@components/C214_TopicBanner/C214_TopicBanner")
);
const C221_AuthorBanner = dynamic(
  () => import("@components/C221_AuthorBanner/C221_AuthorBanner")
);
const C225_LatestBlogs = dynamic(
  () => import("@components/C225_LatestBlogPosts/C225_LatestBlogPosts")
);
const C241_UpcomingProgrammes = dynamic(
  () => import("@components/C241_UpcomingProgrammes/C241_UpcomingProgrammes")
);
const C245_AnimatedNumbers = dynamic(
  () => import("@components/C245_AnimatedNumbers/C245_AnimatedNumbers")
);
const C248_TabbedContent = dynamic(
  () => import("@components/C248_TabbedContent/C248_TabbedContent")
);
const C249_FacultyProfileCarousel = dynamic(
  () =>
    import(
      "@components/C249_FacultyProfileCarousel/C249_FacultyProfileCarousel"
    )
);
const C24_NavigationalCarousel = dynamic(
  () => import("@components/C24_NavigationalCarousel/C24_NavigationalCarousel")
);
const C250_RelatedProgrammes = dynamic(
  () => import("@components/C250_RelatedProgrammes/C250_RelatedProgrammes")
);
const C252_DynamicPieExtended = dynamic(
  () => import("@components/C252_DynamicPie/C252_DynamicPieExtended")
);
const C252_DynamicPieStandard = dynamic(
  () => import("@components/C252_DynamicPie/C252_DynamicPieStandard")
);
const C253_StoriesCallToAction = dynamic(
  () =>
    import(
      "@components/C253_StoriesContainer/C253_StoriesCallToAction/C253_StoriesCallToAction"
    )
);
const C253_StoriesFullWidth = dynamic(
  () =>
    import(
      "@components/C253_StoriesContainer/C253_StoriesFullWidth/C253_StoriesFullWidth"
    )
);
const C253_StoriesIconLink = dynamic(
  () =>
    import(
      "@components/C253_StoriesContainer/C253_StoriesIconLink/C253_StoriesIconLink"
    )
);
const C253_StoriesTextAndImageRight = dynamic(
  () =>
    import(
      "@components/C253_StoriesContainer/C253_StoriesTextAndImageRight/C253_StoriesTextAndImageRight"
    )
);
const C254_ProgrammeCalendar = dynamic(
  () => import("@components/C254_ProgrammeCalendar/C254_ProgrammeCalendar")
);
const C256_ProofPointWrapper = dynamic(
  () => import("@components/C256_ProofPointWrapper/C256_ProofPointWrapper")
);
const C25_NavigationManual = dynamic(
  () => import("@components/C25_NavigationManual/C25_NavigationManual")
);
const C261_Contact = dynamic(
  () => import("@components/C261_Contact/C261_Contact")
);
const C263_ResponsiveImage = dynamic(
  () => import("@components/C263_ResponsiveImage/C263_ResponsiveImage")
);
const C265_ProgrammesByCareerStage = dynamic(
  () =>
    import(
      "@components/C265_ProgrammesByCareerStage/C265_ProgrammesByCareerStage"
    )
);
const C270_CtaContainer = dynamic(
  () => import("@components/C270_CtaContainer/C270_CtaContainer")
);
const C270_CtaContainerLink = dynamic(
  () => import("@components/C270_CtaContainer/C270_CtaContainerLink")
);
const C270_GatedCtaContainerLink = dynamic(
  () => import("@components/C270_CtaContainer/C270_GatedCtaContainerLink")
);
const C271_ThinkCtaContainer = dynamic(
  () => import("@components/C271_ThinkCtaContainer/C271_ThinkCtaContainer")
);
const C272_ProgrammeComparisonTable = dynamic(
  () =>
    import(
      "@components/C272_ProgrammeComparisonTable/C272_ProgrammeComparisonTable"
    )
);
const C27_NavigationalQuote = dynamic(
  () => import("@components/C27_NavigationalQuote/C27_NavigationalQuote")
);
const C280_ArticleDivider = dynamic(
  () => import("@components/C280_ArticleDivider/C280_ArticleDivider")
);
const C281_EditorsChoice = dynamic(
  () => import("@components/C281_EditorsChoice/C281_EditorsChoice")
);
const C282_FacultyCourses = dynamic(
  () => import("@components/C282_FacultyCourses/C282_FacultyCourses")
);
const C282_ProgrammeCourses = dynamic(
  () => import("@components/C282_ProgrammeCourses/C282_ProgrammeCourses")
);
const C282_SubjectAreaCourses = dynamic(
  () => import("@components/C282_SubjectAreaCourses/C282_SubjectAreaCourses")
);
const C283_DonateTool = dynamic(
  () => import("@components/C283_DonateTool/C283_DonateTool")
);
const C286_ExplorePublications = dynamic(
  () => import("@components/C286_ExplorePublications/C286_ExplorePublications")
);
const C29_NavigationalEventsListing = dynamic(
  () =>
    import(
      "@components/C29_NavigationalEventsListing/C29_NavigationalEventsListing"
    )
);
const C44_ContactUsForm = dynamic(
  () => import("@components/C44_ContactUsForm/C44_ContactUsForm")
);
const DPCForm = dynamic(() => import("@components/DPCForm/DPCForm"));
const C45_AlumniJobBoard = dynamic(
  () => import("@components/C45_AlumniJobBoard/C45_AlumniJobBoard")
);
const C46_HeaderBanner = dynamic(
  () => import("@components/C46_HeaderBanner/C46_HeaderBanner")
);
const C63_1_MyProfilePersonalDetails = dynamic(
  () =>
    import(
      "@components/C63_1_MyProfilePersonalDetails/C63_1_MyProfilePersonalDetails"
    )
);
const C64_MyProfilePreferences = dynamic(
  () => import("@components/C64_MyProfilePreferences/C64_MyProfilePreferences")
);
const C65_MyProfileApplications = dynamic(
  () =>
    import("@components/C65_MyProfileApplications/C65_MyProfileApplications")
);
const C66_MyProfileSavedContent = dynamic(
  () =>
    import("@components/C66_MyProfileSavedContent/C66_MyProfileSavedContent")
);
const C67_ChangeEmail = dynamic(
  () => import("@components/C67_ChangeEmailForm/C67_ChangeEmail")
);

const C68_ChangePassword = dynamic(
  () => import("@components/C68_ChangePassword/C68_ChangePassword")
);
const C69_MyProfileEditProfileDetails = dynamic(
  () =>
    import(
      "@components/C69_MyProfileEditProfileDetails/C69_MyProfileEditProfileDetails"
    )
);
const C70_ConfirmChangeEmail = dynamic(
  () => import("@components/C70_ConfirmChangeEmail/C70_ConfirmChangeEmail")
);
const C71_EventRegistrationForm = dynamic(
  () =>
    import("@components/C71_EventRegistrationForm/C71_EventRegistrationForm")
);
const C721_ProgrammeDetailsBarDE = dynamic(
  () =>
    import(
      "@components/C72.1_ProgrammeDetailsBarDE/C72.1_ProgrammeDetailsBarDE"
    )
);
const C722_ProgrammeDetailsBarEMbaMerge = dynamic(
  () =>
    import(
      "@components/C72.2_ProgrammeDetailsBarEMbaMerge/C72.2_ProgrammeDetailsBarEMbaMerge"
    )
);
const C72_ProgrammeDetailsBar = dynamic(
  () => import("@components/C72_ProgrammeDetailsBar/C72_ProgrammeDetailsBar")
);
const C74_ReserveAPlace = dynamic(
  () => import("@components/C74_ReserveAPlace/C74_ReserveAPlace")
);
const COV03_ProgrammeInPageSearch = dynamic(
  () =>
    import(
      "@components/COV03_ProgrammeInPageSearch/COV03_ProgrammeInPageSearch"
    )
);
const ConsultantForm = dynamic(
  () => import("@components/ConsultantForm/ConsultantForm")
);
const CoveoSearchComponent = dynamic(
  () => import("@components/CoveoSearchComponent/CoveoSearchComponent")
);
const DeactivateAccount = dynamic(
  () => import("@components/DeactivateAccount/DeactivateAccount")
);
const DPOTestimonial = dynamic(
  () => import("@components/DPOTestimonial/DPOTestimonial")
);
const DeccPayment = dynamic(
  () => import("@components/DeccPayment/DeccPayment")
);
const EePayment = dynamic(() => import("@components/EePayment/EePayment"));
const DownloadBrochureForm = dynamic(
  () => import("@components/DownloadBrochureForm/DownloadBrochureForm")
);
const RequestCallBackForm = dynamic(
  () => import("@components/RequestCallBackForm/RequestCallBackForm")
);
const RegisterInterestForm = dynamic(
  () => import("@components/RegisterInterestForm/RegisterInterestForm")
);
const EmailSignup = dynamic(
  () => import("@components/EmailSignup/EmailSignup")
);
const GiftAidForAdvancementForm = dynamic(
  () =>
    import("@components/GiftAidForAdvancementForm/GiftAidForAdvancementForm")
);
const GridCTAContainer = dynamic(
  () => import("@components/GridCTAContainer/GridCTAContainer")
);
const ImageCarousel = dynamic(
  () => import("@components/ImageCarousel/ImageCarousel")
);
const InteractApplicationConfirmation = dynamic(
  () =>
    import(
      "@components/InteractApplicationConfirmation/InteractApplicationConfirmation"
    )
);
const LoginOrRegister = dynamic(
  () => import("@components/LoginOrRegister/LoginOrRegister")
);
const MyProfileTabItems = dynamic(
  () => import("@components/MyProfileTabItems/MyProfileTabItems")
);
const News = dynamic(() => import("@components/News/News"));
const PaymentConfirmation = dynamic(
  () => import("@components/PaymentConfirmation/PaymentConfirmation")
);
const PhdFees = dynamic(() => import("@components/PhdFees/PhdFees"));
const ProgrammeApplyNowLink = dynamic(
  () => import("@components/ProgrammeApplyNowLink/ProgrammeApplyNowLink")
);
const ProgrammeEnquiryForm = dynamic(
  () => import("@components/ProgrammeEnquiry/ProgrammeEnquiry")
);
const ProgrammeReserveAPlaceCta = dynamic(
  () =>
    import("@components/ProgrammeReserveAPlaceCta/ProgrammeReserveAPlaceCta")
);
const RegistrationForm = dynamic(
  () => import("@components/RegistrationForm/RegistrationForm")
);
const RequestToJoinMyLbsForm = dynamic(
  () => import("@components/RequestToJoinMyLbsForm/RequestToJoinMyLbsForm")
);
const SiteMap = dynamic(() => import("@components/SiteMap/SiteMap"));
const SubmitCv = dynamic(() => import("@components/SubmitCv/SubmitCv"));
const SubscribeThink = dynamic(
  () => import("@components/SubscribeThink/SubscribeThink")
);
const HowToApplyPage = dynamic(
  () => import("@components/HowToApplyPage/HowToApplyPage")
);
const ErrorBoundary = dynamic(() => import("@components/ErrorBoundary"));
const BlackBaudGenericForm = dynamic(
  () => import("@components/BlackbaudGenericForm/BlackbaudGenericForm")
);
const Auth0Error = dynamic(() => import("@components/Auth0Error/Auth0Error"));
const ServerlessFunctionError = dynamic(
  () => import("@components/ServerlessFunctionError/ServerlessFunctionError")
);
const SelectAutocomplete = dynamic(
  () => import("@components/SelectAutocomplete/SelectAutocomplete")
);
const CTAGatedContent = dynamic(
  () => import("@components/CtaGatedContent/CtaGatedContent")
);
const AvailabilitySelector = dynamic(
  () => import("@components/AvailabilitySelector/AvailabilitySelector")
);
const ModalEMBAMergeForm = dynamic(
  () => import("@components/ModalEMBAMergeForm/ModalEMBAMergeForm")
);

const Components = {
  c284DonationToolNonBlackbaud: C284_DonationTool_NonBlackbaud,
  c285DonationToolGivingTech: C285_DonationTool_GivingTech,
  c271ThinkCtaContainer: C271_ThinkCtaContainer,
  dpoPage: DPOPage,
  facultyProfilePublicationsTabs: C141_FacultyProfilePublications,
  anchorHeading: C03_AnchorHeading,
  authorBanner: C221_AuthorBanner,
  subscribeThink: SubscribeThink,
  animatedNumbers: C245_AnimatedNumbers,
  articleBlockQuote: C210_3_ArticleBlockQuote,
  myProfileTabItems: MyProfileTabItems,
  articleDivider: C280_ArticleDivider,
  articleRichTextTriple: C210_2_ArticleRichTextTriple,
  articleSummary: ArticleSummary,
  brandIconTitle: C200_1_BrandIconTitle,
  bsrContentPage: BSRContentPage,
  c11AccordionWrapper: C11_VerticalAccordion,
  c20PromotionalArticles: C20_PromotionalArticles,
  c252DynamicPieStandard: C252_DynamicPieStandard,
  contact: C261_Contact,
  content: Content,
  content2019Page: Content2019Page,
  contributorProfileDetail: ContributorProfileDetail,
  ctaContainer: C270_CtaContainer,
  ctaContent: C270_CtaContainerLink,
  gatedCtaContent: C270_GatedCtaContainerLink,
  clusterPage: ClusterPage,
  campaignLandingPage2019: CampaignLandingPage,
  c67ChangeEmail: C67_ChangeEmail,
  c68ChangePassword: C68_ChangePassword,
  c70ConfirmChangeEmail: C70_ConfirmChangeEmail,
  deactivateAccount: DeactivateAccount,
  donateTool: C283_DonateTool,
  dpoTestimonial: DPOTestimonial,
  dynamicPie: C252_DynamicPieExtended,
  editorsChoice: C281_EditorsChoice,
  eeLandingPage: EELandingPage,
  emailSignup: EmailSignup,
  embagTemplate: EMBAGTemplate,
  eventsDetail: EventsDetail,
  facultyCourses: C282_FacultyCourses,
  facultyProfileCarousel: C249_FacultyProfileCarousel,
  facultyProfileDetail: FacultyProfileDetail,
  giftAidForAdvancementForm: GiftAidForAdvancementForm,
  gridCtaContainer: GridCTAContainer,
  registrationForm: RegistrationForm,
  requestToJoinMyLbsForm: RequestToJoinMyLbsForm,
  genericCoveoSearchComponent: CoveoSearchComponent,
  headerBanner: C46_HeaderBanner,
  imageCarousel: ImageCarousel,
  interactSso: InteractSSO,
  interactApplicationConfirmation: InteractApplicationConfirmation,
  latestBlogPosts: C225_LatestBlogs,
  loginOrRegister: LoginOrRegister,
  myProfileApplications: C65_MyProfileApplications,
  myProfileEditProfileDetails: C69_MyProfileEditProfileDetails,
  myProfilePersonalDetails: C63_1_MyProfilePersonalDetails,
  myProfilePreferences: C64_MyProfilePreferences,
  myProfileSavedContent: C66_MyProfileSavedContent,
  navigationalCarousel: C24_NavigationalCarousel,
  navigationalEventsListing: C29_NavigationalEventsListing,
  navigationalQuote: C27_NavigationalQuote,
  navigationManual: C25_NavigationManual,
  news: News,
  newsDetail: NewsDetail,
  popularAuthors: C207_PopularAuthors,
  popularTopics: C203_PopularTopics,
  programmeCalendar: C254_ProgrammeCalendar,
  programmeComparisonTable: C272_ProgrammeComparisonTable,
  programmeCourses: C282_ProgrammeCourses,
  programmeDetails: ProgrammeDetailsPage,
  programmeEnquiryForm: ProgrammeEnquiryForm,
  programmeInPageSearch: COV03_ProgrammeInPageSearch,
  programmeReserveAPlaceCta: ProgrammeReserveAPlaceCta,
  programmeApplyNowLink: ProgrammeApplyNowLink,
  programmesByCareerStage: C265_ProgrammesByCareerStage,
  programmeDetailsBarDe: C721_ProgrammeDetailsBarDE,
  programmeDetailsBar: C72_ProgrammeDetailsBar,
  c722ProgrammeDetailsBarEMbaMerge: C722_ProgrammeDetailsBarEMbaMerge,
  promotionalArticlesBsr: C19_1_PromotionalArticlesBSR,
  c194PromotionalResearch: c194PromotionalResearch,
  promotionalArticleSingle: C20_1_PromotionalArticleSingle,
  promotionalArticlesNews: C19_2_PromotionalArticlesNews,
  promotionalEventsFullWidth: C20_2_PromotionalEventsFullWidth,
  promotionalFullWidth: C19_3_1_PromotionalFullWidth,
  promotionalManuallyPopulated: C20_1_PromotionalManuallyPopulated,
  proofPointWrapper: C256_ProofPointWrapper,
  publicationDetail: PublicationDetail,
  quote: C27_NavigationalQuote,
  relatedProgrammes: C250_RelatedProgrammes,
  ResearchDetailsPage: ResearchDetailsPage,
  reserveAPlace: C74_ReserveAPlace,
  eventRegistrationForm: C71_EventRegistrationForm,
  contactUsForm: C44_ContactUsForm,
  dpcForm: DPCForm,
  alumniJobBoard: C45_AlumniJobBoard,
  consultantForm: ConsultantForm,
  downloadBrochureForm: DownloadBrochureForm,
  requestCallBackForm: RequestCallBackForm,
  registerInterestForm: RegisterInterestForm,
  responsiveImage: C263_ResponsiveImage,
  richText: C16_RichTextFullWidth,
  socialSharing: C15_SocialSharing,
  floatingSocialSharing: C15_1_SocialSharing,
  storiesCallToAction: C253_StoriesCallToAction,
  storiesFullWidth: C253_StoriesFullWidth,
  storiesIconLink: C253_StoriesIconLink,
  storiesTextAndImageRight: C253_StoriesTextAndImageRight,
  storyPage: StoryPage,
  studentProfileDetail: StudentProfileDetail,
  subjectAreaCourses: C282_SubjectAreaCourses,
  sublayout: Sublayout,
  submitCv: SubmitCv,
  deccFees: DeccPayment,
  eeFees: EePayment,
  phdFees: PhdFees,
  paymentConfirmation: PaymentConfirmation,
  subNavigationDe: C031_SubNavigationDE,
  subNavigation: C03_SubNavigation,
  downloadBrochureSuccessPage: SuccessBrochurePage,
  registerInterestSuccessPage: RegisterInterestSuccessPage,
  tabbedContent: C248_TabbedContent,
  upcomingProgrammes: C241_UpcomingProgrammes,
  verticalAccordion: C11_VerticalAccordion,
  videoVimeoAndYoutube: C09_VideoVimeoAndYoutube,
  siteMap: SiteMap,
  howToApplyPage: HowToApplyPage,
  blackbaudGenericForm: BlackBaudGenericForm,
  commonSuccessPage: CommonSuccessPage,
  auth0error: Auth0Error,
  serverlessFunctionError: ServerlessFunctionError,
  selectAutocomplete: SelectAutocomplete,
  topicBanner: C214_TopicBanner,
  ctaGatedContent: CTAGatedContent,
  availabilitySelector: AvailabilitySelector,
  explorePublications: C286_ExplorePublications,
  modalEMBAMergeForm: ModalEMBAMergeForm,
};

type BlockProps = {
  component: string;
  uid: string;
};

export const Index = (
  block: BlockProps,
  otherProps?: object,
  globalContent?,
  index?
) => {
  const key = `${block.uid}-${index}`;
  if (typeof Components[block?.component] !== "undefined") {
    return (
      <ErrorBoundary key={key} component={block.component}>
        {React.createElement(Components[block.component], {
          key,
          index,
          content: block,
          ...otherProps,
          globalContent,
        })}
      </ErrorBoundary>
    );
  }
  return React.createElement(
    () => <div>The component {block.component} has not been created yet.</div>,
    { key }
  );
};
export default Index;
